import { Component, Inject, ViewEncapsulation } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

export interface ProtectionPreviewData {
  title: string;
  descriptionHtml: string;
  catalogFileNames: string[];
}

type PreviewDevice = "mobile" | "desktop";

// Mirrors the protection card on the O2O retail platform's Protection Catalog
// page (o2o-retail-platform: features/protection-catalog). Keep in sync.
@Component({
  selector: "app-protection-preview-dialog",
  templateUrl: "./protection-preview-dialog.component.html",
  styleUrls: ["./protection-preview-dialog.component.scss"],
  // Styles must reach the description HTML injected via innerHTML; they are
  // all scoped under .protection-preview instead.
  encapsulation: ViewEncapsulation.None
})
export class ProtectionPreviewDialogComponent {
  device: PreviewDevice = "mobile";

  readonly title: string;
  readonly catalogNames: string[];
  // O2O renders the description with bypassSecurityTrustHtml, so the preview
  // does too; Angular's default sanitizer would strip the editor's inline
  // text/background colours and misrepresent the result.
  readonly description: SafeHtml;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: ProtectionPreviewData,
    sanitizer: DomSanitizer
  ) {
    this.title = data.title?.trim() || "Untitled protection";
    this.catalogNames = data.catalogFileNames.map(stripFileExtension);
    this.description = sanitizer.bypassSecurityTrustHtml(
      data.descriptionHtml ?? ""
    );
  }
}

function stripFileExtension(fileName: string): string {
  const lastDot = fileName.lastIndexOf(".");
  return lastDot > 0 ? fileName.slice(0, lastDot) : fileName;
}
